import React from 'react';
import LazyImage from "./LazyImage"

const NoRecords = ({ className = "w-[24%]" }) => {
    return (
        <div className='navAnimation flex flex-col justify-center items-center bg-white mt-5 py-5 mb-10 rounded-3xl '>
            <LazyImage className={className} src="/img/addReports.png" alt="" />
            <h1 className=' text-2xl font-bold'><span className=' text-blue-950 text-xl'>No Records Found</span></h1>
        </div>
    );
}

export default NoRecords;
